import React, { useEffect, useState } from "react";
import { Button, FloatingLabel, FormControl, FormGroup, Modal, Spinner } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";
import EmployeeStage from "../anlage/new_anlage/EmployeeStage";
import { useAuthState } from "../../context/AuthContext";
import { useQueryClient } from "react-query";

/**
 * 
 * used in: ElvDetailsPage
 * 
 * @param {elv} props object elv
 * @param {show} props bool to show/hide modal
 * @param {setShow} props setter to change show
 */
const ElvTeilVorschreibungModal = (props) => {

    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const {user, contactPerson} = useAuthState();
    const [teilvorschreibungModalBody, setTeilvorschreibungModalBody] = useState("default");
    const [teilvorschreibungModalField, setTeilvorschreibungModalField] = useState("");
    const [teilvorschreibungsModalError, setTeilvorschreibungModalError] = useState("");


    useEffect(() => {
        if (props.show === true) {
            if (user.x_is_house_management === true) {
                if (contactPerson === undefined || contactPerson === null) {
                    setTeilvorschreibungModalBody("contact");
                } 
                else {
                    setTeilvorschreibungModalBody("default");
                }
            }
        }
    }, [props.show])


    // function to check if string is numeric 
    const isNumeric = (value) => {
        return /^-?\d+$/.test(value);
    }


    // function to change Teilvorschreibungsbetrag 
    const teilvorschreibungChangeHandler = () => {
        if (!isNumeric(teilvorschreibungModalField)) {
            setTeilvorschreibungModalError("Es muss ein Zahl sein");
            setTeilvorschreibungModalBody("error");
        } else {
            setTeilvorschreibungModalBody("waiting");
            var data = { id: props.elv.id, betrag: teilvorschreibungModalField }
            if (contactPerson !== undefined && contactPerson !== null) {
                data['contact'] = contactPerson;
            }
            API.post_ElvsTeilvorschrebungsEdit(data)
                .then(() => {
                    queryClient.invalidateQueries("GET_ELVS_DETAILS_QUERY");
                    setTeilvorschreibungModalBody('success');
                })
                .catch(err => {
                    setTeilvorschreibungModalBody("error");
                    if (err.response.data.detail !== undefined) {
                        setTeilvorschreibungModalError(err.response.data.detail);
                    } else {
                        setTeilvorschreibungModalError("Unbekannter Fehler, versuchen Sie später nochmal");
                    }
                })
        }
    }

    
    return (
        <Modal show={props.show} onHide={() => props.setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Teilvorschreibung ändern</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        teilvorschreibungModalBody === "contact" ?
                            <EmployeeStage setStage={setTeilvorschreibungModalBody} setShow={props.setShow} /> :

                        teilvorschreibungModalBody === "default" ?
                            <div>
                                <p>Aktueller Teilvorschreibungsbetrag: {Number(props.elv.x_teilvorschreibung_brutto).toFixed(2)} €</p>
                                <p>Bitte geben Sie Ihren neuen Teilvorschreibungsbetrag ein. Wir leiten Ihren Wunsch an den Energieversorger weiter.</p>
                                <FormGroup>
                                    <FloatingLabel label="Neuer Betrag">
                                        <FormControl type="number" min={10} placeholder="Neuer Betrag" value={teilvorschreibungModalField} onChange={e => setTeilvorschreibungModalField(e.target.value)} />
                                    </FloatingLabel>
                                </FormGroup>
                            </div>
                            :
                            teilvorschreibungModalBody === "waiting" ?
                                <div className="text-center">
                                    <p>Daten werden übermittelt...</p>
                                    <Spinner animation="grow" className="text-energo" /> &nbsp;
                                    <Spinner animation="grow" className="text-energo" /> &nbsp;
                                    <Spinner animation="grow" className="text-energo" />
                                </div>
                                :
                                teilvorschreibungModalBody === "success" ?
                                    <p>Wir haben Ihre Eingabe zur gewünschten Teilvorschreibung erhalten und leiten Ihren Wunsch an den Energielieferanten weiter.</p>
                                    :
                                    teilvorschreibungModalBody === "error" ?
                                        <p className="text-danger text-center">{teilvorschreibungsModalError}</p>
                                        :
                                        null
                    }
                </Modal.Body>
                <Modal.Footer>
                    {
                        teilvorschreibungModalBody === "default" ?
                            <div>
                                <Button variant="danger" onClick={() => props.setShow(false)}>Abbrechen</Button>
                                &nbsp;
                                <Button className="btn-energo" onClick={() => teilvorschreibungChangeHandler()}>Speichern</Button>
                            </div>:
                        teilvorschreibungModalBody === "error" ?
                            <Button variant="warning" onClick={() => setTeilvorschreibungModalBody("default")}>Zurück</Button>:
                        teilvorschreibungModalBody === "success" ?
                            <Button className="text-energo" onClick={() => props.setShow(false)}>Schließen</Button>:
                        null
                    }
                </Modal.Footer>
            </Modal>
    )
}

export default ElvTeilVorschreibungModal;